import { ChangeEvent, forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { InputMask } from 'imask';
import { PricePatternMaskProps } from '../FormPriceField.types';

export const PricePatternMask = forwardRef<HTMLInputElement, PricePatternMaskProps>(({ onChange, ...props }, ref) => {

    /**
     * This handles the callback to our input element onChange.
     * We have to construct a psuedo change event manually to pass it to the
     * input element onChange.
     */
    const handleAccept = (value: string, masked: InputMask, el: InputEvent | undefined) => {

        /**
         * This if statement handles removing the decimal if it is trailing on the string after a backspace
         * We do this by comparing the previous history state of the mask to the current state
         */
        if (
            masked.value.length === masked._selection.end &&
            value[value.length - 1] === '.' &&
            (/^\d*\.{1}\d{1}$/).test(masked.history.states[masked.history.currentIndex].unmaskedValue)
        ) {
            value = value.slice(0, value.length - 1);
            masked._selection.end = masked._selection.end - 1;
        }

        if (onChange) {
            const syntheticEvent = {
                ...el,
                target: {
                    ...el,
                    value: value,
                    selectionEnd: masked._selection.end,
                },
            } as ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

            onChange(syntheticEvent);
        }
    };

    /**
     * This regular expression has two parts to it.
     * ------------------------------------------------------------------------------------------
     * Part 1: \d* => This will match any number of digits 0-9 any number of times.
     * This takes care of all the possible numbers before a user enters a decimal on the price field.
     * ------------------------------------------------------------------------------------------
     * Part 2: (?:\.(?:\d{0,2})?)? => This will make a decimal and between 0-2 digits optionally.
     * This takes care of the optional decimal and decimal numbers that may or may not follow the price,
     * limiting it to 2 digits maximum after the decimal for the price field.
     * ------------------------------------------------------------------------------------------
     */
    const pricePatternMatch: RegExp = /^\d*(?:\.(?:\d{0,2})?)?$/;

    return (
        <IMaskInput
            {...props}
            mask={pricePatternMatch}
            inputRef={ref}
            onAccept={handleAccept}
        />
    );
});